module.exports = __webpack_public_path__ + "static/media/2SD.cf791ede.mp4";